import { sendDelete, sendGet, sendPost, sendPut } from "api/restUtil";
import {useEffect, useMemo, useState} from 'react';
import SearchList from 'components/SearchList';
import ReactDataTableDisplay from 'components/DataTable/ReactDataTableDisplay';
import BasicButton from "components/button/BasicButton";
import { delConfirm, modConfirm, saveConfirm } from "js/common";
import UserAddModModal from "./UserAddModModal";

/**
 * 사용자 목록
 */
export default function UserList() {

	//데이터 목록
	const [ dataList, setDataList ] = useState([]);
	//초기 검색 조건 데이터
	const [ initialCondition, setInitialCondition] = useState({});
	// 페이징 정보
	const [ pagingInfo, setPagingInfo ] = useState({});
	//검색 데이터
	const [ condition, setCondition] = useState({});
	// 등록 팝업
	const [ isOpenAddModal, setIsOpenAddModal] = useState(false);
	// 수정 팝업
	const [ isOpenModModal, setIsOpenModModal] = useState(false);
	// 수정할 데이터
	const [ modInitData, setModInitData ] = useState({});

	//검색 조건
	const conditionList = [
		{
			title : "로그인ID",
			col : "loginId",
			type : "input",
		},
		{
			title : "이름",
			col : "userNm",
			type : "input",
		},
		{
			title : "본사/지점",
			col : "headOfficeYn",
			type : "select",
			option : [
				{label : "전체", value : ""},
				{label : "본사", value : 'Y'},
				{label : "지점", value : "N"},
			]
		},
		{
			title : "지점명",
			col : "branchName",
			type : "input",
		},
	];
	
	
	// 수정 팝업
	const modData = async (data) => {
		setModInitData({userSeq : data.userSeq});
		setIsOpenModModal(true);
	}
	// 삭제
	const delData = async (data) => {
		if(!delConfirm()) return;

		const result = await sendDelete("/api/mgmt/user/" + data.userSeq);
		if(result.respCode === "SUCCESS") {
			alert("삭제 되었습니다.");
			searchList(condition);
		}
	}
	
	//데이터 테이블 컬럼
	const columns = useMemo(() =>[
		{ header : "사용자 순번", col : "userSeq", notView: true },
		{ header : "로그인ID", col : "loginId", cellWidth : "100" },
		{ header : "이름", col : "userNm", cellWidth : "100" },
		{ header : "본사 여부", col : "headOfficeYn", cellWidth : "50" },
		{ header : "지점ID", col : "branchId", notView: true },
		{ header : "지점명", col : "branchName", cellWidth : "50" },
		{ header : "수정", col : "userSeq", cellWidth : "30", type : "modButton", onClick: modData},
		{ header : "삭제", col : "userSeq", cellWidth : "30", type : "delButton", onClick: delData},
	], []);

	useEffect(() =>{
		const initData = async () => {
			
			//초기 검색 조건
			setInitialCondition({});
			searchList({});
		};

		initData();

	}, []);

	//목록 조회
	const searchList = async (cond = {}) => {
		// cond.cntPerPage = 2;
		let result = await sendGet("/api/mgmt/user", cond);
		if(result.respCode === "SUCCESS"){

			setCondition(cond);

			setDataList(result.data.list);
			setPagingInfo({...result.data, searchFnc : searchList, searchCond : cond});
		}
	}

	/**
	 * 사용자 등록
	 * @param {*} data 
	 * @returns 
	 */
	const addUser = async (data) => {
		if(!saveConfirm()) return;

		const result = await sendPost("/api/mgmt/user", data);
		if(result.respCode === "SUCCESS") {
			alert("등록되었습니다.");
			searchList(condition);
			setIsOpenAddModal(false);
		}
	}

	/**
	 * 사용자 수정
	 * @param {*} data 
	 * @returns 
	 */
	const modUser = async (data) => {
		if(!modConfirm()) return;

		const result = await sendPut("/api/mgmt/user/" + data.userSeq, data);
		if(result.respCode === "SUCCESS") {
			alert("수정되었습니다.");
			searchList(condition);
			setIsOpenModModal(false);
		}

	}


	return (
		<div className="ant-tabs-tabpane">
			<SearchList conditionList={conditionList} onSearch={searchList} initialData={initialCondition} />

			<div className="table-buttons mg-t-10 mg-b-10">
				<BasicButton
					label="추가"
					className="btn-add"
					onClick={() => setIsOpenAddModal(true)}
				/>
				{/* <BasicButton
					label="삭제"
					className="btn-del"
					disabled={selectedAdminList.length === 0}
					// selectRow={selectedAdminList}
					onClick={deleteAdmin}
				/> */}
			</div>

			<ReactDataTableDisplay
				columns={columns}
				customDatas={dataList}
				hideCheckBox={true}
				percentageWidth={true}
				isPageNation={false}
				rowClick={"checkbox"}
				pagingInfo={pagingInfo}
			/>
			{/* 사용자 등록 */}
			<UserAddModModal
				isOpen={isOpenAddModal}
				initData={{}}
				returnData={addUser}
				onClose={()=> setIsOpenAddModal(false)}
				title="지점 등록"
			/>
			{/* 사용자 수정 */}
			<UserAddModModal
				isOpen={isOpenModModal}
				initData={modInitData}
				returnData={modUser}
				onClose={()=> {setIsOpenModModal(false); setModInitData({});}}
				title="지점 수정"
			/>

		</div>
	);
}